module.exports = __webpack_public_path__ + "static/media/is_children_room.a5b7fd4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/is_children_room.svg
// module id = 1434
// module chunks = 0